import React from 'react';
import EmployeeRoleTypeForm from './EmployeeRoleTypeForm';
import Stack from 'components/common/Stack';
import { useUser } from 'auth/UserHooks';
import { trackComponent } from 'telemetry/AppInsights';

const AddEmployeeRoleTypePage = props => {
  const user = useUser();

  const employeeId = props.location.state.employeeId;

  const navigateToEmployee = () => {
    if (employeeId === user.id) props.history.push('/');
    else props.history.push(`/employees/${employeeId}`);
  };

  return (
    <Stack>
      <EmployeeRoleTypeForm
        isCreateMode
        employeeId={employeeId}
        onCancel={navigateToEmployee}
        onSubmit={navigateToEmployee}
      />
    </Stack>
  );
};

export default trackComponent(AddEmployeeRoleTypePage, 'Add Employee Role Type Page');
